import * as React from 'react';

import { ECompletionYearType, NonEmptyArray } from '../../../../../JsonQuery';
import { Filter } from '../common/Filter';
import { CheckboxButtonGroupUnselectable } from '../../CheckboxButtonGroupUnselectable';
import { getCompletionYearOptions } from './helpers';

interface ICompletionYearProps {
  yearOffset: number;
  value: NonEmptyArray<ECompletionYearType> | null;
  onChange(value: NonEmptyArray<ECompletionYearType> | null): void;
}

export const CompletionYear: React.FC<ICompletionYearProps> = ({ yearOffset, value, onChange }) => {
  const completionOptions = getCompletionYearOptions(yearOffset);

  return (
    <Filter id="advancedFilter_completionYear" label="Год сдачи ЖК">
      <CheckboxButtonGroupUnselectable options={completionOptions} value={value} onChange={onChange} />
    </Filter>
  );
};
